export enum FileTypeEnum {
    IMAGE = 'image',
    VIDEO = 'video',
}
